import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ActiveDotIcon, BackIcon, CloseIcon, InactiveDotIcon } from "../../../asset";
import style from "./AdditionalProofsAdd.module.css";
import axios from "axios";
import { ROUTES } from "../../../constant/routeConstant";
import { useLocation, useNavigate } from "react-router-dom";
import { GROLOG_BASE_URL, GROLOG_URL } from "../../../constant/apiConstant";
import Breadcumbs from '../../../component/page-components/breadcumbs/breadcumbs';
import { useDispatch, useSelector } from "react-redux";
import { Timeline } from "antd";
import moment from "moment";
import DeleteConfirmationModal from "../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../component/modal/SuccessModal";
import { doDelete } from "../../../api/baseAPI";
import { checkValidationToken } from "../../../util/errorHandler";
import CustomDivider from "../../../component/divider/CustomDivider";

const AdditionalProofsDetail = () => {
	const { token, client_id, grolog_account_id, userId } = useSelector((state) => state.auth);
	let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
	const api = GROLOG_URL
	const { t } = useTranslation();
	const navigate = useNavigate();
	const location = useLocation();
	const [detail, setDetail] = useState([]);
	const [managementHistoryList, setManagementHistoryList] = useState([])
	const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false)
	const [successModalOpen, setSuccessModalOpen] = useState(false)

	const dispatch = useDispatch()

	const [userManagementOpen, setUserManagementOpen] = useState(false)

	useEffect(() => {
		fetchData();
		getManagementHistoryList()
	}, []);

	const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
		const url = api + endpoint;
		const method = "PUT";
		const headers = { "Authorization": token };
		const request = { url, method, headers, data };
		return axios(request);
	};

	const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
		const url = api + endpoint;
		const method = "GET";
		const headers = { "Authorization": token };
		const request = { url, method, headers, params };
		return axios(request);
	};

	const doGetBaseUrl = async (endpoint, tkn, params, dispatch, refresh_token) => {
		const url = GROLOG_BASE_URL + endpoint;
		const method = "GET";
		const headers = { "Authorization": token };
		const request = { url, method, headers, params };
		return axios(request);
	};

	const fetchData = async () => {
		let id = 1;
		let res = await doGet(`/additional-proofs/${location.state}?${param}`, token);
		setDetail(res?.data?.payload?.data);
	};

	const getManagementHistoryList = async () => {
		let res = await doGetBaseUrl(`audit/v1/grolog/audit?page=1&filter=table_name eq additional_proofs, primary_key eq ${location.state}`)

		const data = res?.data?.payload
		const reorderedData = []

		if (data !== null) {
			for (let i = data.length - 1; i >= 0; i--) {
				const element = data[i];
				reorderedData.push(element)
			}
		}

		setManagementHistoryList(reorderedData)
	}

	const convertTimestamp = (timestamp, isSpecific) => {
		const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
			"Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
		];
		const monthNumbers = ["01", "02", "03", "04", "05", "06",
			"07", "08", "09", "10", "11", "12"
		];

		// Extract components from the timestamp string
		const year = timestamp?.substring(0, 4);
		const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
		const day = timestamp?.substring(8, 10);

		let dateFormat = new Date(year, month, day);

		if (isSpecific) {
			return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
		} else {
			return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
		}
	}

	const convertToTime = (timestamp) => {
		let time = new Date(timestamp);
		return (moment(timestamp).utc().format('HH:mm'))
	}

	const backToList = () => {
		navigate(ROUTES.ADDITIONAL_PROOFS.LIST);
	};

	const handleEdit = (id) => {
		navigate(ROUTES.ADDITIONAL_PROOFS.EDIT, { state: id });
	};

	const deleteAdditionalProof = async (token, refresh_token, id, updated_at, dispatch) => {
		const url = `${GROLOG_URL}/skill-set/${id}`
		let result = { data: undefined, ok: false }

		let data = {
			'updated_at': updated_at
		}

		try {
			const response = await doDelete(url, token, data)
			if (response) {
				result.ok = true
				result.data = response?.data?.payload?.data
			}
		} catch (error) {
			checkValidationToken(error, token, refresh_token, dispatch)
		}
		return result
	}

	const handleDelete = async (id, updatedAt) => {
		try {
			const response = await deleteAdditionalProof(token, null, id, updatedAt, dispatch)
			if (response && response.ok) {
				setDeleteConfirmationModalOpen(false)
				setSuccessModalOpen(true)
			}
		} catch (error) {
			console.log(error)
		}
	}

	return (
		<>
			<div className="p-[24px] flex flex-col gap-[24px]">

				<DeleteConfirmationModal
					isOpen={deleteConfirmationModalOpen}
					onOk={() => setDeleteConfirmationModalOpen(false)}
					onCancel={() => handleDelete(detail?.id, detail?.updated_at)}
					closable={false}
					width={440}
					className={style.modalContainer}
					okText="Cancel"
					cancelText="Yes, Delete"
					title="Delete Data?"
					description={<p>Are you Sure want to delete <strong>{detail?.additional_name}</strong>?</p>}
				/>

				<SuccessModal
					isOpen={successModalOpen}
					onOk={() => navigate(ROUTES.ADDITIONAL_PROOFS.LIST)}
					closable={false}
					width={280}
					className={style.deleteModal}
					okText="Ok"
					title="Success"
					description="Your data has been deleted"
				/>

				<Breadcumbs
					jmlLevel={4}
					menuLevel1={`Setup`}
					menuLevel2={`Profile Configuration`}
					menuLevel3={`Additional Proofs`}
					menuLevel4={`Detail Registration Number of Employee`}
				/>

				<div className="flex items-center justify-between">
					<div onClick={() => navigate(ROUTES.ADDITIONAL_PROOFS.LIST)} className="cursor-pointer flex items-center gap-[22px]">
						<img
							src={BackIcon}
							alt=""

							className="cursor-pointer"
						/>
						<h1 className="font-sans-bold text-2xl cursor-pointer" id="title" onClick={() => backToList()}>
							Detail Registration Number of Employee
						</h1>
					</div>

					<div className='bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer' onClick={() => setUserManagementOpen(true)}>
						<p className='text-[#666666]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at, true)}</strong> | {t("USER_DETAIL:LAST_MODIFIED_BY")} <strong>{detail?.updated_by_name}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.updated_at, true)}</strong></p>
					</div>
				</div>

				<div
					style={{
						marginTop: 24,
						padding: 30,
						minHeight: 512,
						borderRadius: "6px",
						backgroundColor: "white",
						boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
					}}
				>
					<div className={style.tabsContainer + ""}>
        <CustomDivider name={"Additional Proofs Information"} />
						<div className="flex">
							<div>
								<div className="flex">
									<div className="gap-[40px] mb-[24px]">
										{/* <div className="w-[500px] mb-[24px]"> */}
											{/* <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
												{t("Additional Proofs Information")}
											</h3> */}
										{/* </div> */}

										{/* //one */}
										<div className="gap-[40px] mb-[24px]">
											<div className="w-[350px] mb-[24px]">
												<label className="font-roboto text-[14px] text-[#818181]">
													{t("Additional Name")}
												</label>
												<h4 className="font-roboto text-[20px] text-[#424242]">
													{detail?.additional_name}
												</h4>
											</div>
											<div className="w-[350px] mb-[24px]">
												<label className="font-roboto text-[14px] text-[#818181]">
													{t("Additional Description")}
												</label>
												<h4 className="font-roboto text-[20px] text-[#424242]">
													{detail?.description}
												</h4>
											</div>
											<div className="w-[350px] mb-[24px]">
												<label className="font-roboto text-[14px] text-[#818181]">
													{t("Additional to Menu")}
												</label>
												<h4 className="font-roboto text-[20px] text-[#424242]">
													{detail?.to_menu}
												</h4>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-row-reverse justify-start gap-[16px]">
					<button className="bg-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-white-100 font-sans text-[18px]" onClick={() => handleEdit(detail?.id)}>
						{t("SKILLSET_DETAIL:EDIT_BUTTON")}
					</button>
					<button className="border-[2px] border-[#CF0000] font-medium rounded-[6px] w-[96px] h-[44px] text-[#CF0000] font-sans text-[18px]" onClick={() => setDeleteConfirmationModalOpen(true)}>
						{t("SKILLSET_DETAIL:DELETE_BUTTON")}
					</button>
				</div>

				<aside className={userManagementOpen ? "duration-300 ease-out transition-all right-0 w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto" : "duration-300 ease-out transition-all right-[-400px] w-[400px] h-full fixed top-0 z-20 bg-[#FFFFFF] px-[24px] py-[20px] shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] overflow-auto"}>
					<button className='absolute top-[21px] right-[21px]' onClick={() => setUserManagementOpen(false)}>
						<img src={CloseIcon} alt="" />
					</button>

					<h3 className='font-sans font-[600] text-[#1D1D1D] text-[20px]'>{t("USER_DETAIL:DATA_MANAGEMENT_HISTORY")}</h3>
					<p className='font-sans font-[400] text-[#818181] text-[12px] mb-[24px]'>{t("USER_DETAIL:CREATED_BY")}  <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")} <strong>{convertTimestamp(detail?.created_at)}</strong></p>


					<div className={style.timelineContainer}>
						<Timeline>
							{
								managementHistoryList.map((item, index) => {
									if (index === 0) {
										return (
											<Timeline.Item dot={<img src={ActiveDotIcon} />}>
												<div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
													<h4 className={"text-[#CF0000] font-[500] text-[14px]"}>{t("USER_DETAIL:LAST_MODIFIED")}</h4>
													<h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
													<p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
												</div>
											</Timeline.Item>
										)
									} else {
										return (
											<Timeline.Item dot={<img src={InactiveDotIcon} />}>
												<div className='flex flex-col gap-[8px] border-b-[##DDDDDD] border-b-[1px] pb-[16px]'>
													<h4 className={"font-[500]"}>{t("USER_DETAIL:MODIFIED")}</h4>
													<h4 className='font-[500] text-[14px] text-[#424242]'>{item.alias_name}</h4>
													<p className='font-[400] text-[14px]'>{`${convertTimestamp(item.created_at)} • ${convertToTime(item.created_at)}`}</p>
												</div>
											</Timeline.Item>
										)
									}
								})
							}
						</Timeline>
					</div>
				</aside>
			</div>
		</>
	);
};
export default AdditionalProofsDetail;
